import { act, useEffect, useState } from "react";
import imageMapResize from "image-map-resizer";
import { useFetchData } from "../hooks/useFetchData";
import ImageLoader from "./ImageLoader";
import ImagePopup from "./ImagePopup";
import Default from "./outerCicle/Default";
import Level2 from "./outerCicle/Level2";
import Level3 from "./outerCicle/Level3";
import Level4 from "./outerCicle/Level4";
import Level5 from "./outerCicle/Level5";
import Level6 from "./outerCicle/Level6";
import axios from "axios";

const LearningWheel = () => {
  const learningData = useFetchData(); // fetch data hook
  const [currentImage, setCurrentImage] = useState("imagedivl0");
  const [showSublinksDiv, setShowSublinksDiv] = useState(false); // category
  const [sublinksData, setSublinksData] = useState({});
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [currentPopupImage, setCurrentPopupImage] = useState(null);
  const [selectedKey, setSelectedKey] = useState(null); // to highlight the selected link
  const [imageLoading, setImageLoading] = useState(false);
  const [actionsData, setActionsData] = useState({
    level: null,
    category: null,
    key: null,
    sublinks: null,
  });

  useEffect(() => {
    imageMapResize();
    setShowSublinksDiv(false);
  }, [currentImage]);

  const hideOtherImageDivs = () => {
    setCurrentImage(null);
  };

  // outer level functions
  const L0OuterL2 = () => {
    console.log("L0outer2");
    hideOtherImageDivs();
    setCurrentImage("imagedivl2");
    setActionsData({ level: 2, category: null, key: null, sublinks: null });
  };
  const L0OuterL3 = () => {
    console.log("L0outer3");
    hideOtherImageDivs();
    setCurrentImage("imagedivl3");
    setActionsData({
      level: 3,
      category: null,
      key: null,
      sublinks: null,
    });
  };
  const L0OuterL4 = () => {
    console.log("L0outer4");
    hideOtherImageDivs();
    setCurrentImage("imagedivl4");
    setActionsData({
      level: 4,
      category: null,
      key: null,
      sublinks: null,
    });
  };
  const L0OuterL5 = () => {
    console.log("L0outer5");
    hideOtherImageDivs();
    setCurrentImage("imagedivl5");
    // ****** for now add a pop up coming soon
    // setLevel5Popup(true);

    setActionsData({ level: 5, category: null, key: null, sublinks: null });
  };
  const L0OuterL6 = () => {
    console.log("L0outer6");
    hideOtherImageDivs();
    setCurrentImage("imagedivl6");
    // ****** for now add a pop up coming soon
    // setLevel6Popup(true);

    setActionsData({ level: 6, category: null, key: null, sublinks: null });
  };
  // level 2 category functions
  const L2Business = () => {
    console.log("L2Business");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl2Business");
    setActionsData({
      level: 2,
      category: "business",
      key: null,
      sublinks: null,
    });
  };
  const L2Core = () => {
    console.log("L2Core");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl2Core");
    setActionsData({
      level: 2,
      category: "core",
      key: null,
      sublinks: null,
    });
  };
  const L2Leadership = () => {
    console.log("L2Leadership");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl2Leadership");
    setActionsData({
      level: 2,
      category: "leadership",
      key: null,
      sublinks: null,
    });
  };
  const L2Self = () => {
    console.log("L2Self");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl2Self");

    setActionsData({ level: 2, category: "self", key: null, sublinks: null });
  };
  // level 3 category functions
  const L3Business = () => {
    console.log("L3Business");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl3Business");
    setActionsData({
      level: 3,
      category: "business",
      key: null,
      sublinks: null,
    });
  };
  const L3Core = () => {
    console.log("L3Core");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl3Core");
    setActionsData({ level: 3, category: "core", key: null, sublinks: null });
  };
  const L3Leadership = () => {
    console.log("L3Leadership");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl3Leadership");
    setActionsData({
      level: 3,
      category: "leadership",
      key: null,
      sublinks: null,
    });
  };
  const L3Self = () => {
    console.log("L3Self");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl3Self");
    setActionsData({ level: 3, category: "self", key: null, sublinks: null });
  };
  // level 4 category functions
  const L4Business = () => {
    console.log("L4Business");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl4Business");
    setActionsData({
      level: 4,
      category: "business",
      key: null,
      sublinks: null,
    });
  };
  const L4Core = () => {
    console.log("L4Core");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl4Core");
    setActionsData({ level: 4, category: "core", key: null, sublinks: null });
  };
  const L4Leadership = () => {
    console.log("L4Leadership");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl4Leadership");
    setActionsData({
      level: 4,
      category: "leadership",
      key: null,
      sublinks: null,
    });
  };
  const L4Self = () => {
    console.log("L4Self");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl4Self");

    setActionsData({ level: 4, category: "self", key: null, sublinks: null });
  };
  // level 5 category functions
  const L5Business = () => {
    console.log("L5Business");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl5Business");

    setActionsData({
      level: 5,
      category: "business",
      key: null,
      sublinks: null,
    });
  };
  const L5Core = () => {
    console.log("L5Core");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl5Core");
    setActionsData({ level: 5, category: "core", key: null, sublinks: null });
  };
  const L5Leadership = () => {
    console.log("L5Leadership");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl5Leadership");
    setActionsData({
      level: 5,
      category: "leadership",
      key: null,
      sublinks: null,
    });
  };
  const L5Self = () => {
    console.log("L5Self");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl5Self");
    setActionsData({ level: 5, category: "self", key: null, sublinks: null });
  };
  // level 6 category functions
  const L6Business = () => {
    console.log("L6Business");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl6Business");
    setActionsData({
      level: 6,
      category: "business",
      key: null,
      sublinks: null,
    });
  };
  const L6Core = () => {
    console.log("L6Core");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl6Core");
    setActionsData({ level: 6, category: "core", key: null, sublinks: null });
  };
  const L6Leadership = () => {
    console.log("L6Leadership");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl6Leadership");
    setActionsData({
      level: 6,
      category: "leadership",
      key: null,
      sublinks: null,
    });
  };
  const L6Self = () => {
    console.log("L6Self");
    setSelectedKey(null);
    hideOtherImageDivs();
    setCurrentImage("imagedivl6Self");
    setActionsData({ level: 6, category: "self", key: null, sublinks: null });
  };

  // *** handle level 2 categories ***
  // level 2 business subcategories
  const handleL2Business = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level2"]["business"][key]);
    setSelectedKey(key);
    setActionsData({
      level: 2,
      category: "business",
      key: key,
      sublinks: null,
    });
  };
  // level 2 core subcategories
  const handleL2Core = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level2"]["core"][key]);
    setSelectedKey(key);
    setActionsData({
      level: 2,
      category: "core",
      key: key,
      sublinks: null,
    });
  };
  // level 2 leadership subcategories
  const handleL2Leadership = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level2"]["leadership"][key]);
    setSelectedKey(key);
    setActionsData({
      level: 2,
      category: "leadership",
      key: key,
      sublinks: null,
    });
  };
  // level 2 self subcategories
  const handleL2Self = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level2"]["self"][key]);
    setSelectedKey(key);

    setActionsData({
      level: 2,
      category: "self",
      key: key,
      sublinks: null,
    });
  };

  // *** handle level 3 categories ***
  // level 3 business subcategories
  const handleL3Business = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level3"]["business"][key]);
    setSelectedKey(key);

    setActionsData({
      level: 3,
      category: "business",
      key: key,
      sublinks: null,
    });
  };
  // level 3 core subcategories
  const handleL3Core = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level3"]["core"][key]);
    setSelectedKey(key);

    setActionsData({
      level: 3,
      category: "core",
      key: key,
      sublinks: null,
    });
  };
  // level 3 leadership subcategories
  const handleL3Leadership = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level3"]["leadership"][key]);
    setSelectedKey(key);
    setActionsData({
      level: 3,
      category: "leadership",
      key: key,
      sublinks: null,
    });
  };
  // level 3 self subcategories
  const handleL3Self = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level3"]["self"][key]);
    setSelectedKey(key);

    setActionsData({
      level: 3,
      category: "self",
      key: key,
      sublinks: null,
    });
  };

  // *** handle level 4 categories ***
  // level 4 business subcategories
  const handleL4Business = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level4"]["business"][key]);
    setSelectedKey(key);
    setActionsData({
      level: 4,
      category: "business",
      key: key,
      sublinks: null,
    });
  };
  // level 4 core subcategories
  const handleL4Core = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level4"]["core"][key]);
    setSelectedKey(key);
    setActionsData({
      level: 4,
      category: "core",
      key: key,
      sublinks: null,
    });
  };
  // level 4 leadership subcategories
  const handleL4Leadership = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level4"]["leadership"][key]);
    setSelectedKey(key);

    setActionsData({
      level: 4,
      category: "leadership",
      key: key,
      sublinks: null,
    });
  };
  // level 4 self subcategories
  const handleL4Self = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level4"]["self"][key]);
    setSelectedKey(key);

    setActionsData({
      level: 4,
      category: "self",
      key: key,
      sublinks: null,
    });
  };

  // *** handle level 5 categories ***
  // level 5 business subcategories
  const handleL5Business = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level5"]["business"][key]);
    setSelectedKey(key);

    setActionsData({
      level: 5,
      category: "business",
      key: key,
      sublinks: null,
    });
  };
  // level 5 core subcategories
  const handleL5Core = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level5"]["core"][key]);
    setSelectedKey(key);

    setActionsData({
      level: 5,
      category: "core",
      key: key,
      sublinks: null,
    });
  };
  // level 5 leadership subcategories
  const handleL5Leadership = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level5"]["leadership"][key]);
    setSelectedKey(key);

    setActionsData({
      level: 5,
      category: "leadership",
      key: key,
      sublinks: null,
    });
  };
  // level 5 self subcategories
  const handleL5Self = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level5"]["self"][key]);
    setSelectedKey(key);

    setActionsData({
      level: 5,
      category: "self",
      key: key,
      sublinks: null,
    });
  };

  // *** handle level 6 categories ***
  // level 6 business subcategories
  const handleL6Business = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level6"]["business"][key]);
    setSelectedKey(key);

    setActionsData({
      level: 6,
      category: "business",
      key: key,
      sublinks: null,
    });
  };
  // level 6 core subcategories
  const handleL6Core = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level6"]["core"][key]);
    setSelectedKey(key);

    setActionsData({
      level: 6,
      category: "core",
      key: key,
      sublinks: null,
    });
  };
  // level 6 leadership subcategories
  const handleL6Leadership = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level6"]["leadership"][key]);
    setSelectedKey(key);

    setActionsData({
      level: 6,
      category: "leadership",
      key: key,
      sublinks: null,
    });
  };
  // level 6 self subcategories
  const handleL6Self = (key) => {
    setShowSublinksDiv(true);
    setSublinksData(learningData["level6"]["self"][key]);
    setSelectedKey(key);

    setActionsData({
      level: 6,
      category: "self",
      key: key,
      sublinks: null,
    });
  };

  // image pop up
  const handleImagePopup = async (pic) => {
    setShowImagePopup(true);
    setImageLoading(true);
    setTimeout(() => {
      setImageLoading(false);
    }, 900);
    // take the image from the server
    setCurrentPopupImage(`${process.env.REACT_APP_IMAGE_URL}/${pic}`);

    // to do: post the actions data here
    try {
      const params = new URLSearchParams();
      params.append("level", actionsData?.level);
      params.append("category", actionsData?.category);
      params.append("key", actionsData?.key);
      params.append("sublink", pic);

      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/saveFrameworkUsage`,
        params,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      );
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="flex flex-col justify-start items-center p-4 w-full h-screen font-heebo">
      {/* <div className="flex items-center justify-between w-full px-4 py-3 border-b border-[#342c6e]/20 bg-white shadow-sm">
        <div className="flex items-center gap-3">
          <img
            src="assets/images/isp_logo01.png"
            className="h-10 w-auto object-contain"
            alt="ISP Logo"
          />
          <div className="h-8 w-px bg-[#342c6e]/30" />
          <span className="text-[#342c6e] font-bold tracking-widest uppercase text-xs sm:text-sm md:text-base leading-tight">
            Sales Capability Framework
          </span>
        </div>
      </div> */}
      <div className="flex justify-center md:justify-start items-start w-full h-full pt-4 md:pt-8 lg:pt-12 overflow-x-auto px-2 sm:px-6 md:px-10 lg:px-14">
        {/* default */}
        <Default
          currentImage={currentImage}
          L0OuterL2={L0OuterL2}
          L0OuterL3={L0OuterL3}
          L0OuterL4={L0OuterL4}
          L0OuterL5={L0OuterL5}
          L0OuterL6={L0OuterL6}
        />
        {/* level 2 */}
        <Level2
          currentImage={currentImage}
          L0OuterL3={L0OuterL3}
          L0OuterL4={L0OuterL4}
          L0OuterL5={L0OuterL5}
          L0OuterL6={L0OuterL6}
          L2Business={L2Business}
          L2Core={L2Core}
          L2Leadership={L2Leadership}
          L2Self={L2Self}
        />
        {/* level 3 */}
        <Level3
          currentImage={currentImage}
          L0OuterL2={L0OuterL2}
          L0OuterL4={L0OuterL4}
          L0OuterL5={L0OuterL5}
          L0OuterL6={L0OuterL6}
          L3Business={L3Business}
          L3Core={L3Core}
          L3Leadership={L3Leadership}
          L3Self={L3Self}
        />
        {/* level 4 */}
        <Level4
          currentImage={currentImage}
          L0OuterL2={L0OuterL2}
          L0OuterL3={L0OuterL3}
          L0OuterL5={L0OuterL5}
          L0OuterL6={L0OuterL6}
          L4Business={L4Business}
          L4Core={L4Core}
          L4Leadership={L4Leadership}
          L4Self={L4Self}
        />
        {/* level 5 */}
        <Level5
          currentImage={currentImage}
          L0OuterL2={L0OuterL2}
          L0OuterL3={L0OuterL3}
          L0OuterL4={L0OuterL4}
          L0OuterL6={L0OuterL6}
          L5Business={L5Business}
          L5Core={L5Core}
          L5Leadership={L5Leadership}
          L5Self={L5Self}
        />
        {/* level 6 */}
        <Level6
          currentImage={currentImage}
          L0OuterL2={L0OuterL2}
          L0OuterL3={L0OuterL3}
          L0OuterL4={L0OuterL4}
          L0OuterL5={L0OuterL5}
          L6Business={L6Business}
          L6Core={L6Core}
          L6Leadership={L6Leadership}
          L6Self={L6Self}
        />
        {/* level 2 business */}
        <div
          className={`${currentImage !== "imagedivl2Business" ? "hidden" : ""}`}
        >
          <div className="" id="imagedivl2Business">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L2Business 1.png"
                  useMap="#l2business"
                  className="w-80 h-80"
                  alt="L2 Business"
                />
                <map name="l2business" id="l2business">
                  <area
                    className="cursor-pointer"
                    alt="L2 Business Outer L6"
                    onClick={L0OuterL6}
                    coords="401,1179,446,1070,379,1037,328,1005,286,974,203,1058,286,1119"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Business Outer L5"
                    onClick={L0OuterL5}
                    coords="9,534,131,547,146,459,177,399,192,366,80,321,33,423"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Business Outer L4"
                    onClick={L0OuterL4}
                    coords="385,48,437,158,512,139,558,133,626,127,625,3,500,14"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Business Outer L3"
                    onClick={L0OuterL3}
                    coords="1000,314,1100,242,1139,298,1170,357,1202,435,1087,469,1059,392"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Business Core"
                    onClick={L2Core}
                    coords="618,607,856,366,618,136"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Business Leadership"
                    onClick={L2Leadership}
                    coords="140,608,367,375,606,608"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Business Self"
                    onClick={L2Self}
                    coords="609,1092,608,621,376,862"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l2 business links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(
                    learningData?.["level2"]?.["business"] ?? {},
                  )?.map((key, index) => (
                    <div
                      key={index}
                      className={`cursor-pointer py-0.5 text-right pr-4 ${
                        selectedKey === key ? "bg-black text-white" : ""
                      }`}
                      onClick={() => handleL2Business(key)}
                    >
                      {key}
                    </div>
                  ))}
                </div>
                {/* l2 business sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l2 business pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 2 core */}
        <div className={`${currentImage !== "imagedivl2Core" ? "hidden" : ""}`}>
          <div className="" id="imagedivl2Core">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L2Core 1.png"
                  useMap="#l2core"
                  className="w-80 h-80"
                  alt="L2 Core"
                />
                <map name="l2core" id="l2core">
                  <area
                    className="cursor-pointer"
                    alt="L2 Core Outer L6"
                    onClick={L0OuterL6}
                    coords="401,1179,434,1066,385,1038,346,1025,311,995,291,977,212,1067,286,1123"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Core Outer L5"
                    onClick={L0OuterL5}
                    coords="3,524,126,542,137,490,156,453,169,413,180,389,69,329,36,409"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Core Outer L4"
                    onClick={L0OuterL4}
                    coords="383,51,429,169,509,141,576,133,619,127,606,5,476,20"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Core Outer L3"
                    onClick={L0OuterL3}
                    coords="1091,235,1000,319,1049,387,1073,439,1085,480,1198,438,1159,338"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Core Self"
                    onClick={L2Self}
                    coords="132,610,608,613,367,377"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Core Leadership"
                    onClick={L2Leadership}
                    coords="614,607,851,365,616,138"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Core Business"
                    onClick={L2Business}
                    coords="611,1094,607,620,376,859"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l2 core links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(learningData?.["level2"]?.["core"] ?? {})?.map(
                    (key, index) => (
                      <div
                        key={index}
                        className={`cursor-pointer py-0.5 text-right pr-4 ${
                          selectedKey === key ? "bg-black text-white" : ""
                        }`}
                        onClick={() => handleL2Core(key)}
                      >
                        {key}
                      </div>
                    ),
                  )}
                </div>
                {/* l2 core sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l2 core pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 2 leadership */}
        <div
          className={`${
            currentImage !== "imagedivl2Leadership" ? "hidden" : ""
          }`}
        >
          <div className="" id="imagedivl2Leadership">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L2Leadership 1.png"
                  useMap="#l2leadership"
                  className="w-80 h-80"
                  alt="L2 Leadership"
                />
                <map name="l2leadership" id="l2leadership">
                  <area
                    className="cursor-pointer"
                    alt="L2 Leadership Outer L6"
                    onClick={L0OuterL6}
                    coords="400,1181,442,1069,383,1043,339,1009,294,980,216,1069,290,1120"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Leadership Outer L5"
                    onClick={L0OuterL5}
                    coords="9,528,127,533,147,471,165,418,182,388,66,339,28,417"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Leadership Outer L4"
                    onClick={L0OuterL4}
                    coords="366,61,419,169,519,137,609,128,606,5,500,15,438,30"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Leadership Outer L3"
                    onClick={L0OuterL3}
                    coords="1101,241,1006,319,1040,362,1066,414,1087,468,1205,435,1163,332"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Leadership Self"
                    onClick={L2Self}
                    coords="607,618,371,855,611,1091"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Leadership Business"
                    onClick={L2Business}
                    coords="619,133,854,367,621,603"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Leadership Core"
                    onClick={L2Core}
                    coords="134,611,611,611,367,377"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l2 leadership links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(
                    learningData?.["level2"]?.["leadership"] ?? {},
                  )?.map((key, index) => (
                    <div
                      key={index}
                      className={`cursor-pointer py-0.5 text-right pr-4 ${
                        selectedKey === key ? "bg-black text-white" : ""
                      }`}
                      onClick={() => handleL2Leadership(key)}
                    >
                      {key}
                    </div>
                  ))}
                </div>
                {/* l2 leadership sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l2 leadership pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 2 self */}
        <div className={`${currentImage !== "imagedivl2Self" ? "hidden" : ""}`}>
          <div className="" id="imagedivl2Self">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L2Self 1.png"
                  useMap="#l2self"
                  className="w-80 h-80"
                  alt="L2 Self"
                />
                <map name="l2self" id="l2self">
                  <area
                    className="cursor-pointer"
                    alt="L2 Self Outer L6"
                    onClick={L0OuterL6}
                    coords="396,1177,445,1068,386,1038,316,994,289,975,213,1070,291,1128"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Self Outer L5"
                    onClick={L0OuterL5}
                    coords="10,526,130,544,149,462,191,375,74,319,35,421"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Self Outer L4"
                    onClick={L0OuterL4}
                    coords="393,49,438,162,499,141,566,126,617,126,615,5,494,14"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Self Outer L3"
                    onClick={L0OuterL3}
                    coords="1002,311,1101,244,1150,307,1178,367,1207,439,1091,480,1060,402"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Self Business"
                    onClick={L2Business}
                    coords="608,615,367,383,136,611"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Self Core"
                    onClick={L2Core}
                    coords="620,605,861,367,620,136"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L2 Self Leadership"
                    onClick={L2Leadership}
                    coords="611,622,376,861,614,1096"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l2 self links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(learningData?.["level2"]?.["self"] ?? {})?.map(
                    (key, index) => (
                      <div
                        key={index}
                        className={`cursor-pointer py-0.5 text-right pr-4 ${
                          selectedKey === key ? "bg-black text-white" : ""
                        }`}
                        onClick={() => handleL2Self(key)}
                      >
                        {key}
                      </div>
                    ),
                  )}
                </div>
                {/* l2 self sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l2 core pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 3 business */}
        <div
          className={`${currentImage !== "imagedivl3Business" ? "hidden" : ""}`}
        >
          <div className="" id="imagedivl3Business">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L3Business 1.png"
                  useMap="#l3business"
                  className="w-80 h-80"
                  alt="L3 Business"
                />
                <map name="l3business" id="l3business">
                  <area
                    className="cursor-pointer"
                    alt="L3 Business Outer L6"
                    onClick={L0OuterL6}
                    coords="12,526,132,540,151,459,178,402,188,383,78,323,41,395"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Business Outer L5"
                    onClick={L0OuterL5}
                    coords="369,60,416,171,503,140,583,133,616,129,610,8,503,16"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Business Outer L4"
                    onClick={L0OuterL4}
                    coords="1002,314,1100,241,1155,318,1184,395,1202,450,1093,484,1063,412"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Business Outer L2"
                    onClick={L0OuterL2}
                    coords="402,1176,438,1066,384,1041,325,997,285,971,205,1055,282,1118"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Business Core"
                    onClick={L3Core}
                    coords="617,605,620,141,863,369"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Business Leadership"
                    onClick={L3Leadership}
                    coords="138,610,367,376,612,610"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Business Self"
                    onClick={L3Self}
                    coords="378,859,614,620,612,1092"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l3 business links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(
                    learningData?.["level3"]?.["business"] ?? {},
                  )?.map((key, index) => (
                    <div
                      key={index}
                      className={`cursor-pointer py-0.5 text-right pr-4 ${
                        selectedKey === key ? "bg-black text-white" : ""
                      }`}
                      onClick={() => handleL3Business(key)}
                    >
                      {key}
                    </div>
                  ))}
                </div>
                {/* l3 business sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l3 business pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 3 core */}
        <div className={`${currentImage !== "imagedivl3Core" ? "hidden" : ""}`}>
          <div className="" id="imagedivl3Core">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L3Core 1.png"
                  useMap="#l3core"
                  className="w-80 h-80"
                  alt="L3 Core"
                />
                <map name="l3core" id="l3core">
                  <area
                    className="cursor-pointer"
                    alt="L3 Core Outer L6"
                    onClick={L0OuterL6}
                    coords="9,538,130,553,148,486,166,419,203,363,90,302,43,401"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Core Outer L5"
                    onClick={L0OuterL5}
                    coords="380,53,441,161,503,143,568,132,621,130,612,3,491,19"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Core Outer L4"
                    onClick={L0OuterL4}
                    coords="1002,314,1099,244,1147,311,1180,381,1203,447,1091,486,1055,400"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Core Outer L2"
                    onClick={L0OuterL2}
                    coords="413,1180,451,1068,381,1034,330,1004,283,965,197,1046,273,1108,323,1140"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Core Self"
                    onClick={L3Self}
                    coords="133,611,371,373,610,608"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Core Leadership"
                    onClick={L3Leadership}
                    coords="617,135,857,368,621,608"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Core Business"
                    onClick={L3Business}
                    coords="612,1089,610,617,377,856"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l3 core links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(learningData?.["level3"]?.["core"] ?? {})?.map(
                    (key, index) => (
                      <div
                        key={index}
                        className={`cursor-pointer py-0.5 text-right pr-4 ${
                          selectedKey === key ? "bg-black text-white" : ""
                        }`}
                        onClick={() => handleL3Core(key)}
                      >
                        {key}
                      </div>
                    ),
                  )}
                </div>
                {/* l3 core sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l3 core pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 3 leadership */}
        <div
          className={`${
            currentImage !== "imagedivl3Leadership" ? "hidden" : ""
          }`}
        >
          <div className="" id="imagedivl3Leadership">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L3Leadership 1.png"
                  useMap="#l3leadership"
                  className="w-80 h-80"
                  alt="L3 Leadership"
                />
                <map name="l3leadership" id="l3leadership">
                  <area
                    className="cursor-pointer"
                    alt="L3 Leadership Outer L6"
                    onClick={L0OuterL6}
                    coords="10,540,130,545,149,468,163,418,192,376,85,319,36,411"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Leadership Outer L5"
                    onClick={L0OuterL5}
                    coords="348,68,417,172,502,147,569,127,641,126,629,4,494,18"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Leadership Outer L4"
                    onClick={L0OuterL4}
                    coords="1000,310,1100,244,1145,299,1188,389,1208,457,1096,489,1063,409"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Leadership Outer L2"
                    onClick={L0OuterL2}
                    coords="403,1179,444,1069,398,1038,342,1010,300,976,220,1068,292,1126"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Leadership Core"
                    onClick={L3Core}
                    coords="614,1089,611,620,374,857"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Leadership Self"
                    onClick={L3Self}
                    coords="620,136,859,366,623,603"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Leadership Business"
                    onClick={L3Business}
                    coords="136,608,369,375,609,609"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l3 leadership links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(
                    learningData?.["level3"]?.["leadership"] ?? {},
                  ).map((key, index) => (
                    <div
                      key={index}
                      className={`cursor-pointer py-0.5 text-right pr-4 ${
                        selectedKey === key ? "bg-black text-white" : ""
                      }`}
                      onClick={() => handleL3Leadership(key)}
                    >
                      {key}
                    </div>
                  ))}
                </div>
                {/* l3 leadership sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l3 leadership pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 3 self */}
        <div className={`${currentImage !== "imagedivl3Self" ? "hidden" : ""}`}>
          <div className="" id="imagedivl3Self">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L3Self 1.png"
                  useMap="#l3self"
                  className="w-80 h-80"
                  alt="L3 Self"
                />
                <map name="l3self" id="l3self">
                  <area
                    className="cursor-pointer"
                    alt="L3 Self Outer L6"
                    onClick={L0OuterL6}
                    coords="12,540,130,552,151,464,176,401,203,365,79,323,35,425"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Self Outer L5"
                    onClick={L0OuterL5}
                    coords="365,64,417,175,512,140,602,130,639,127,648,12,567,13,470,26"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Self Outer L4"
                    onClick={L0OuterL4}
                    coords="993,304,1102,245,1166,339,1206,454,1093,492,1057,399"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Self Outer L2"
                    onClick={L0OuterL2}
                    coords="403,1179,442,1068,384,1036,314,993,277,957,200,1059,287,1125"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Self Business"
                    onClick={L3Business}
                    coords="132,613,371,378,610,614"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Self Core"
                    onClick={L3Core}
                    coords="621,609,621,135,858,368"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L3 Self Leadership"
                    onClick={L3Leadership}
                    coords="613,622,374,860,614,1092"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l3 self links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(learningData?.["level3"]?.["self"] ?? {})?.map(
                    (key, index) => (
                      <div
                        key={index}
                        className={`cursor-pointer py-0.5 text-right pr-4 ${
                          selectedKey === key ? "bg-black text-white" : ""
                        }`}
                        onClick={() => handleL3Self(key)}
                      >
                        {key}
                      </div>
                    ),
                  )}
                </div>
                {/* l3 self sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l3 core pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 4 business */}
        <div
          className={`${currentImage !== "imagedivl4Business" ? "hidden" : ""}`}
        >
          <div className="" id="imagedivl4Business">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L4Business 1.png"
                  useMap="#l4business"
                  className="w-80 h-80"
                  alt="L4 Business"
                />
                <map name="l4business" id="l4business">
                  <area
                    className="cursor-pointer"
                    alt="L4 Business Outer L6"
                    onClick={L0OuterL6}
                    coords="369,58,421,165,493,141,573,129,625,126,624,5,493,19"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Business Outer L5"
                    onClick={L0OuterL5}
                    coords="1093,484,1206,455,1169,348,1096,229,993,300,1052,382"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Business Outer L3"
                    onClick={L0OuterL3}
                    coords="418,1182,442,1072,375,1037,305,988,215,1070,292,1128"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Business Outer L2"
                    onClick={L0OuterL2}
                    coords="9,532,124,547,143,484,161,425,195,369,77,322,31,419"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Business Core"
                    onClick={L4Core}
                    coords="617,130,856,369,624,603"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Business Leadership"
                    onClick={L4Leadership}
                    coords="132,610,368,376,607,612"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Business Self"
                    onClick={L4Self}
                    coords="614,1095,612,622,378,859"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l4 business links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(
                    learningData?.["level4"]?.["business"] ?? {},
                  )?.map((key, index) => (
                    <div
                      key={index}
                      className={`cursor-pointer py-0.5 text-right pr-4 ${
                        selectedKey === key ? "bg-black text-white" : ""
                      }`}
                      onClick={() => handleL4Business(key)}
                    >
                      {key}
                    </div>
                  ))}
                </div>
                {/* l4 business sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l4 business pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 4 core */}
        <div className={`${currentImage !== "imagedivl4Core" ? "hidden" : ""}`}>
          <div className="" id="imagedivl4Core">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L4Core 1.png"
                  useMap="#l4core"
                  className="w-80 h-80"
                  alt="L4 Core"
                />
                <map name="l4core" id="l4core">
                  <area
                    className="cursor-pointer"
                    alt="L4 Core Outer L6"
                    onClick={L0OuterL6}
                    coords="383,50,438,162,504,143,557,132,604,130,633,125,626,2,493,16"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Core Outer L5"
                    onClick={L0OuterL5}
                    coords="1001,316,1103,244,1148,316,1179,375,1207,447,1096,492,1060,407"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Core Outer L3"
                    onClick={L0OuterL3}
                    coords="411,1186,446,1070,355,1025,288,975,211,1066,299,1128"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Core Outer L2"
                    onClick={L0OuterL2}
                    coords="10,528,128,546,147,480,173,414,188,379,79,323,30,423"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Core Business"
                    onClick={L4Business}
                    coords="614,623,372,859,612,1092"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Core Leadership"
                    onClick={L4Leadership}
                    coords="619,135,858,366,621,609"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Core Self"
                    onClick={L4Self}
                    coords="133,610,368,377,610,610"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l4 core links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(learningData?.["level4"]?.["core"] ?? {})?.map(
                    (key, index) => (
                      <div
                        key={index}
                        className={`cursor-pointer py-0.5 text-right pr-4 ${
                          selectedKey === key ? "bg-black text-white" : ""
                        }`}
                        onClick={() => handleL4Core(key)}
                      >
                        {key}
                      </div>
                    ),
                  )}
                </div>
                {/* l4 core sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l4 core pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 4 leadership */}
        <div
          className={`${
            currentImage !== "imagedivl4Leadership" ? "hidden" : ""
          }`}
        >
          <div className="" id="imagedivl4Leadership">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L4Leadership 1.png"
                  useMap="#l4leadership"
                  className="w-80 h-80"
                  alt="L4 Leadership"
                />
                <map name="l4leadership" id="l4leadership">
                  <area
                    className="cursor-pointer"
                    alt="L4 Leadership Outer L6"
                    onClick={L0OuterL6}
                    coords="374,55,435,163,493,140,554,134,613,125,623,5,500,15"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Leadership Outer L5"
                    onClick={L0OuterL5}
                    coords="1002,310,1099,242,1145,309,1180,377,1208,455,1094,486,1057,399"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Leadership Outer L3"
                    onClick={L0OuterL3}
                    coords="406,1181,444,1067,382,1042,324,1004,293,976,211,1058,292,1129"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Leadership Outer L2"
                    onClick={L0OuterL2}
                    coords="11,536,128,548,143,473,172,404,197,352,91,305,36,411"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Leadership Core"
                    onClick={L4Core}
                    coords="611,1093,613,620,374,862"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Leadership Self"
                    onClick={L4Self}
                    coords="624,135,857,370,621,606"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Leadership Business"
                    onClick={L4Business}
                    coords="136,610,370,378,610,608"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l4 leadership links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(
                    learningData?.["level4"]?.["leadership"] ?? {},
                  ).map((key, index) => (
                    <div
                      key={index}
                      className={`cursor-pointer py-0.5 text-right pr-4 ${
                        selectedKey === key ? "bg-black text-white" : ""
                      }`}
                      onClick={() => handleL4Leadership(key)}
                    >
                      {key}
                    </div>
                  ))}
                </div>
                {/* l4 leadership sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l4 leadership pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 4 self */}
        <div className={`${currentImage !== "imagedivl4Self" ? "hidden" : ""}`}>
          <div className="" id="imagedivl4Self">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L4Self 1.png"
                  useMap="#l4self"
                  className="w-80 h-80"
                  alt="L4 Self"
                />
                <map name="l4self" id="l4self">
                  <area
                    className="cursor-pointer"
                    alt="L4 Self Outer L6"
                    onClick={L0OuterL6}
                    coords="253,123,331,220,393,187,449,160,527,139,609,129,693,130,751,141,793,32,724,14,643,5,530,8,416,37,329,69"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Self Outer L5"
                    onClick={L0OuterL5}
                    coords="950,108,889,213,966,273,1015,323,1066,423,1103,523,1114,599,1234,589,1217,485,1187,377,1115,245,1033,167"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Self Outer L3"
                    onClick={L0OuterL3}
                    coords="557,1099,545,1215,446,1196,342,1157,245,1096,192,1043,136,979,110,945,212,888,271,956,343,1021,439,1069"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Self Outer L2"
                    onClick={L0OuterL2}
                    coords="12,702,131,695,127,643,127,547,156,431,210,339,289,250,179,189,109,262,54,362,18,477,1,571"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Self Business"
                    onClick={L4Business}
                    coords="615,610,615,377,372,372,134,611"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Self Core"
                    onClick={L4Core}
                    coords="618,132,865,365,862,613,618,617"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L4 Self Leadership"
                    onClick={L4Leadership}
                    coords="368,615,609,617,611,1097,373,859"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l4 self links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(learningData?.["level4"]?.["self"] ?? {})?.map(
                    (key, index) => (
                      <div
                        key={index}
                        className={`cursor-pointer py-0.5 text-right pr-4 ${
                          selectedKey === key ? "bg-black text-white" : ""
                        }`}
                        onClick={() => handleL4Self(key)}
                      >
                        {key}
                      </div>
                    ),
                  )}
                </div>
                {/* l4 self sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l4 self pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 5 business */}
        <div
          className={`${currentImage !== "imagedivl5Business" ? "hidden" : ""}`}
        >
          <div className="" id="imagedivl5Business">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L5Business 1.png"
                  useMap="#l5business"
                  className="w-80 h-80"
                  alt="L5 Business"
                />
                <map name="l5business" id="l5business">
                  <area
                    className="cursor-pointer"
                    alt="L5 Business Outer L6"
                    onClick={L0OuterL6}
                    coords="862,192,953,105,1074,203,1173,347,1216,479,1233,617,1111,613,1080,453,1001,309"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Business Outer L4"
                    onClick={L0OuterL4}
                    coords="411,1186,452,1069,371,1033,281,965,187,1047,298,1135"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Business Outer L3"
                    onClick={L0OuterL3}
                    coords="6,538,127,549,143,494,169,428,193,375,79,309,31,411"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Business Outer L2"
                    onClick={L0OuterL2}
                    coords="371,56,430,165,518,137,603,129,649,130,641,5,491,18"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Business Core"
                    onClick={L5Core}
                    coords="621,606,617,133,861,368"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Business Self"
                    onClick={L5Self}
                    coords="612,610,368,377,138,611"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Business Leadership"
                    onClick={L5Leadership}
                    coords="610,622,375,862,614,1089"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l5 business links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(
                    learningData?.["level5"]?.["business"] ?? {},
                  )?.map((key, index) => (
                    <div
                      key={index}
                      className={`cursor-pointer py-0.5 text-right pr-4 ${
                        selectedKey === key ? "bg-black text-white" : ""
                      }`}
                      onClick={() => handleL5Business(key)}
                    >
                      {key}
                    </div>
                  ))}
                </div>
                {/* l5 business sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l5 business pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 5 core */}
        <div className={`${currentImage !== "imagedivl5Core" ? "hidden" : ""}`}>
          <div className="" id="imagedivl5Core">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L5Core 1.png"
                  useMap="#l5core"
                  className="w-80 h-80"
                  alt="L5 Core"
                />
                <map name="l5core" id="l5core">
                  <area
                    className="cursor-pointer"
                    alt="L5 Core Outer L6"
                    onClick={L0OuterL6}
                    coords="1002,305,1100,240,1137,295,1178,374,1208,452,1094,492,1065,405"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Core Outer L4"
                    onClick={L0OuterL4}
                    coords="403,1178,439,1065,372,1037,300,984,224,1072,300,1135"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Core Outer L3"
                    onClick={L0OuterL3}
                    coords="9,535,133,541,150,472,185,385,84,318,42,410"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Core Outer L2"
                    onClick={L0OuterL2}
                    coords="378,54,434,162,549,136,617,128,620,8,502,9"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Core Leadership"
                    onClick={L5Leadership}
                    coords="605,611,369,378,138,609"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Core Self"
                    onClick={L5Self}
                    coords="620,137,859,367,619,604"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Core Business"
                    onClick={L5Business}
                    coords="613,1095,612,623,375,861"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l5 core links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(learningData?.["level5"]?.["core"] ?? {})?.map(
                    (key, index) => (
                      <div
                        key={index}
                        className={`cursor-pointer py-0.5 text-right pr-4 ${
                          selectedKey === key ? "bg-black text-white" : ""
                        }`}
                        onClick={() => handleL5Core(key)}
                      >
                        {key}
                      </div>
                    ),
                  )}
                </div>
                {/* l5 core sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l5 core pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 5 leadership */}
        <div
          className={`${
            currentImage !== "imagedivl5Leadership" ? "hidden" : ""
          }`}
        >
          <div className="" id="imagedivl5Leadership">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L5Leadership 1.png"
                  useMap="#l5leadership"
                  className="w-80 h-80"
                  alt="L5 Leadership"
                />
                <map name="l5leadership" id="l5leadership">
                  <area
                    className="cursor-pointer"
                    alt="L5 Leadership Outer L6"
                    onClick={L0OuterL6}
                    coords="1000,315,1105,244,1161,333,1205,445,1096,487,1063,402"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Leadership Outer L4"
                    onClick={L0OuterL4}
                    coords="416,1186,453,1073,371,1029,297,982,216,1066,286,1122"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Leadership Outer L3"
                    onClick={L0OuterL3}
                    coords="7,550,129,553,152,457,183,384,72,332,33,426"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Leadership Outer L2"
                    onClick={L0OuterL2}
                    coords="358,58,421,170,515,147,607,132,612,8,487,15"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Leadership Self"
                    onClick={L5Self}
                    coords="612,1089,611,622,380,861"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Leadership Business"
                    onClick={L5Business}
                    coords="135,611,368,380,605,610"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Leadership Core"
                    onClick={L5Core}
                    coords="624,140,854,367,621,606"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l5 leadership links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(
                    learningData?.["level5"]?.["leadership"] ?? {},
                  ).map((key, index) => (
                    <div
                      key={index}
                      className={`cursor-pointer py-0.5 text-right pr-4 ${
                        selectedKey === key ? "bg-black text-white" : ""
                      }`}
                      onClick={() => handleL5Leadership(key)}
                    >
                      {key}
                    </div>
                  ))}
                </div>
                {/* l5 leadership sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l5 leadership pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 5 self */}
        <div className={`${currentImage !== "imagedivl5Self" ? "hidden" : ""}`}>
          <div className="" id="imagedivl5Self">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L5Self 1.png"
                  useMap="#l5self"
                  className="w-80 h-80"
                  alt="L5 Self"
                />
                <map name="l5self" id="l5self">
                  <area
                    className="cursor-pointer"
                    alt="L5 Self Outer L6"
                    onClick={L0OuterL6}
                    coords="1000,309,1094,232,1146,308,1204,428,1208,456,1096,497,1063,409"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Self Outer L4"
                    onClick={L0OuterL4}
                    coords="411,1184,445,1070,367,1032,297,982,222,1073,290,1129"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Self Outer L3"
                    onClick={L0OuterL3}
                    coords="6,547,130,556,149,471,188,377,74,330,34,420"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Self Outer L2"
                    onClick={L0OuterL2}
                    coords="375,55,438,165,530,137,615,126,617,5,498,14"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Self Business"
                    onClick={L5Business}
                    coords="136,610,367,373,605,612"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Self Core"
                    onClick={L5Core}
                    coords="622,137,858,366,621,602"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L5 Self Leadership"
                    onClick={L5Leadership}
                    coords="612,623,375,859,612,1091"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l5 self links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(learningData?.["level5"]?.["self"] ?? {})?.map(
                    (key, index) => (
                      <div
                        key={index}
                        className={`cursor-pointer py-0.5 text-right pr-4 ${
                          selectedKey === key ? "bg-black text-white" : ""
                        }`}
                        onClick={() => handleL5Self(key)}
                      >
                        {key}
                      </div>
                    ),
                  )}
                </div>
                {/* l5 self sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l5 self pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 6 business */}
        <div
          className={`${currentImage !== "imagedivl6Business" ? "hidden" : ""}`}
        >
          <div className="" id="imagedivl6Business">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L6Business 1.png"
                  useMap="#l6business"
                  className="w-80 h-80"
                  alt="L6 Business"
                />
                <map name="l6business" id="l6business">
                  <area
                    className="cursor-pointer"
                    alt="L6 Business Outer L5"
                    onClick={L0OuterL5}
                    coords="22,814,152,768,207,889,414,1059,613,1106,609,1216,362,1183,125,1007"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Business Outer L4"
                    onClick={L0OuterL4}
                    coords="238,129,313,227,180,399,131,589,172,813,23,827,-1,622,14,473,57,337,142,210"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Business Outer L3"
                    onClick={L0OuterL3}
                    coords="204,129,461,1,752,1,876,50,993,121,866,210,713,141,465,153,298,254"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Business Outer L2"
                    onClick={L0OuterL2}
                    coords="808,168,873,53,1093,197,1196,369,1230,508,1232,614,1105,618,1078,460,1002,319,901,220"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Business Core"
                    onClick={L6Core}
                    coords="621,606,617,133,861,368"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Business Self"
                    onClick={L6Self}
                    coords="612,610,368,377,138,611"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Business Leadership"
                    onClick={L6Leadership}
                    coords="610,622,375,862,614,1089"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l6 business links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(
                    learningData?.["level6"]?.["business"] ?? {},
                  )?.map((key, index) => (
                    <div
                      key={index}
                      className={`cursor-pointer py-0.5 text-right pr-4 ${
                        selectedKey === key ? "bg-black text-white" : ""
                      }`}
                      onClick={() => handleL6Business(key)}
                    >
                      {key}
                    </div>
                  ))}
                </div>
                {/* l6 business sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l6 business pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 6 core */}
        <div className={`${currentImage !== "imagedivl6Core" ? "hidden" : ""}`}>
          <div className="" id="imagedivl6Core">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L6Core 1.png"
                  useMap="#l6core"
                  className="w-80 h-80"
                  alt="L6 Core"
                />
                <map name="l6core" id="l6core">
                  <area
                    className="cursor-pointer"
                    alt="L6 Core Outer L5"
                    onClick={L0OuterL5}
                    coords="16,779,142,734,222,897,400,1051,611,1110,598,1216,426,1199,261,1122,152,1033,90,950,53,882,34,824"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Core Outer L4"
                    onClick={L0OuterL4}
                    coords="288,272,228,321,188,398,136,517,136,702,195,856,52,880,0,796,2,508,60,330,144,168,175,192,227,207"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Core Outer L3"
                    onClick={L0OuterL3}
                    coords="853,196,928,159,932,68,675,1,423,17,230,115,173,172,263,291,427,172,619,140,679,155,767,163,813,178"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Core Outer L2"
                    onClick={L0OuterL2}
                    coords="815,164,908,60,1042,142,1160,300,1227,478,1234,616,1103,614,1054,421,943,261"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Core Leadership"
                    onClick={L6Leadership}
                    coords="605,611,369,378,138,609"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Core Self"
                    onClick={L6Self}
                    coords="620,137,859,367,619,604"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Core Business"
                    onClick={L6Business}
                    coords="613,1095,612,623,375,861"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l6 core links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(learningData?.["level6"]?.["core"] ?? {})?.map(
                    (key, index) => (
                      <div
                        key={index}
                        className={`cursor-pointer py-0.5 text-right pr-4 ${
                          selectedKey === key ? "bg-black text-white" : ""
                        }`}
                        onClick={() => handleL6Core(key)}
                      >
                        {key}
                      </div>
                    ),
                  )}
                </div>
                {/* l6 core sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l6 core pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 6 leadership */}
        <div
          className={`${
            currentImage !== "imagedivl6Leadership" ? "hidden" : ""
          }`}
        >
          <div className="" id="imagedivl6Leadership">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L6Leadership 1.png"
                  useMap="#l6leadership"
                  className="w-80 h-80"
                  alt="L6 Leadership"
                />
                <map name="l6leadership" id="l6leadership">
                  <area
                    className="cursor-pointer"
                    alt="L6 Leadership Outer L5"
                    onClick={L0OuterL5}
                    coords="157,737,11,789,131,1013,325,1185,511,1222,620,1221,614,1107,414,1062,228,910"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Leadership Outer L4"
                    onClick={L0OuterL4}
                    coords="75,295,177,176,273,274,158,460,129,608,172,800,40,856,-1,664,8,470"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Leadership Outer L3"
                    onClick={L0OuterL3}
                    coords="213,145,294,264,453,168,706,150,864,200,960,96,759,12,467,3"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Leadership Outer L2"
                    onClick={L0OuterL2}
                    coords="782,165,850,39,990,118,1080,198,1152,307,1203,408,1220,496,1227,614,1101,614,1076,448,985,300,886,213"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Leadership Self"
                    onClick={L6Self}
                    coords="612,1089,611,622,380,861"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Leadership Business"
                    coords="135,611,368,380,605,610"
                    onClick={L6Business}
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Leadership Core"
                    onClick={L6Core}
                    coords="624,140,854,367,621,606"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l6 leadership links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(
                    learningData?.["level6"]?.["leadership"] ?? {},
                  ).map((key, index) => (
                    <div
                      key={index}
                      className={`cursor-pointer py-0.5 text-right pr-4 ${
                        selectedKey === key ? "bg-black text-white" : ""
                      }`}
                      onClick={() => handleL6Leadership(key)}
                    >
                      {key}
                    </div>
                  ))}
                </div>
                {/* l6 leadership sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l6 leadership pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* level 6 self */}
        <div className={`${currentImage !== "imagedivl6Self" ? "hidden" : ""}`}>
          <div className="" id="imagedivl6Self">
            <div className="relative w-full align-bottom flex flex-col lg:flex-row">
              <div className="z-10 relative">
                <img
                  src="assets/images/L6Self 1.png"
                  useMap="#l6self"
                  className="w-80 h-80"
                  alt="L6 Self"
                />
                <map name="l6self" id="l6self">
                  <area
                    className="cursor-pointer"
                    alt="L6 Self Outer L5"
                    onClick={L0OuterL5}
                    coords="158,787,271,952,383,1047,622,1110,614,1222,353,1171,156,1027,38,829"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Self Outer L4"
                    onClick={L0OuterL4}
                    coords="194,146,292,256,221,351,146,479,140,727,204,892,86,937,16,754,5,509,71,309"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Self Outer L3"
                    onClick={L0OuterL3}
                    coords="902,216,977,90,760,7,463,3,217,128,311,246,540,136,718,150"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Self Outer L2"
                    onClick={L0OuterL2}
                    coords="768,153,836,36,973,101,1053,178,1141,285,1189,383,1225,519,1225,606,1111,607,1076,426,933,247"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Self Business"
                    onClick={L6Business}
                    coords="136,610,367,373,605,612"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Self Core"
                    onClick={L6Core}
                    coords="622,137,858,366,621,602"
                    shape="poly"
                  />
                  <area
                    className="cursor-pointer"
                    alt="L6 Self Leadership"
                    onClick={L6Leadership}
                    coords="612,623,375,859,612,1091"
                    shape="poly"
                  />
                </map>
              </div>
              {/* l6 self links */}
              <div className="md:absolute md:bottom-0 md:left-[50%] z-2 mt-4 md:mt-0">
                <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                  Capabilites
                </p>
                <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                  {Object.keys(learningData?.["level6"]?.["self"] ?? {})?.map(
                    (key, index) => (
                      <div
                        key={index}
                        className={`cursor-pointer py-0.5 text-right pr-4 ${
                          selectedKey === key ? "bg-black text-white" : ""
                        }`}
                        onClick={() => handleL6Self(key)}
                      >
                        {key}
                      </div>
                    ),
                  )}
                </div>
                {/* l6 self sublinks */}
                {showSublinksDiv && (
                  <div className="md:absolute md:bottom-0 md:left-[100%] z-20 mt-4 md:mt-0">
                    <p className="block md:hidden my-2 text-lg text-center text-[#342c6e] font-semibold">
                      Competencies
                    </p>
                    <div className="bg-[#EFF1FF] h-36 md:h-[159px] w-full md:w-[450px] overflow-auto border-[#342c6e] border-2 rounded-sm shadow-lg">
                      {Object.keys(sublinksData).length > 0 ? (
                        Object.keys(sublinksData)?.map((key, index) => (
                          <div
                            key={index}
                            className="cursor-pointer py-0.5 text-left pl-4 text-[#448CC9]"
                            onClick={() =>
                              handleImagePopup(sublinksData[key]?.pic)
                            }
                          >
                            {key} <span className="px-2"></span>
                            {sublinksData[key]?.title}
                          </div>
                        ))
                      ) : (
                        <div className="flex h-full w-full justify-start items-start pl-3 pt-0.5 text-gray-500 font-semibold text-md">
                          None Applicable
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {/* l6 self pop up */}
                {showImagePopup && (
                  <ImagePopup
                    imageLoading={imageLoading}
                    setShowImagePopup={setShowImagePopup}
                    currentPopupImage={currentPopupImage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearningWheel;
